import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-icon-showcase',
  templateUrl: './brand-icon-showcase.component.html',
  styleUrls: ['./brand-icon-showcase.component.scss']
})
export class BrandIconShowcaseComponent {
  lastClicked: string = '';

  onLogoClick(label: string): void {
    this.lastClicked = label;
  }
}
